module.exports = __webpack_public_path__ + "static/media/spiderman 1000*1500 .82f01355.jpg";